import React from 'react';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from '../Login/Login';

export default function LoginRoute() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/gestao" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
